import { each, filter } from 'lodash';

function Sortable() {
  'ngInject';

  return {
    initialSort,
    update,
    getElementsInRange,
    getIndex,
    setIndex,
    removeIndex,
    isSortable
  };

  /**
   * @param {HTMLCollection} children
   */
  function initialSort(children) {

    each(children, (child, index) => {
      setIndex(child, index);
    });

  }

  /**
   * @param {[HTMLElement]} children
   * @param {Number} currentIndex
   * @param {Number} targetIndex
   * @returns {[HTMLElement]}
   */
  function update(children, currentIndex, targetIndex) {

    let isMovingTargetDown = currentIndex > targetIndex;

    each(children, (child) => {

      const index = getIndex(child);

      if (isMovingTargetDown) {
        setIndex(child, index + 1);
      } else {
        setIndex(child, index - 1);
      }

    });

  }

  /**
   * @param {[HTMLElement]} children
   * @param {Number} currentIndex
   * @param {Number} targetIndex
   * @returns {[HTMLElement]}
   */
  function getElementsInRange(children, currentIndex, targetIndex) {

    return filter(children, (item) => {

      const index = getIndex(item);

      if (currentIndex > targetIndex) {
        return index >= targetIndex && index < currentIndex;
      }

      if (currentIndex < targetIndex) {
        return index <= targetIndex && index > currentIndex;
      }

    });

  }

  /**
   * @param {HTMLElement} target
   * @returns {Number}
   */
  function getIndex(target) {
    return Number(target.dataset.sortableIndex);
  }

  /**
   * @param {HTMLElement} target
   * @param {String|Number} index
   * @returns {Number}
   */
  function setIndex(target, index) {
    return target.dataset.sortableIndex = index;
  }

  /**
   * @param {HTMLElement} target
   */
  function removeIndex(target) {
    target.dataset.sortableIndex = null;
  }

  /**
   * @param {HTMLElement} target
   * @returns {Boolean}
   */
  function isSortable(target) {
    if (target) {
      return Boolean(target.dataset.sortable);
    }

    return false;
  }
}

export {Sortable};
